<template>
  <v-select
    v-model="selected"
    :items="allRoles"
    item-value="id"
    item-text="label"
    attach
    chips
    deletable-chips
    label="Roles"
    :multiple="multiple"
    @change="change"
  />
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      multiple: {
        type: Boolean,
        default: true
      },
      initRole: {
        type: String,
        default: ''
      },
      initRoles: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        selected: this.multiple
          ? this.initRoles || []
          : this.initRole || '',
        previousSelection: this.multiple
          ? this.initRoles || []
          : this.initRole || ''
      }
    },
    computed: {
      ...mapGetters([ 'allRoles' ])
    },
    // created() {
    //   this.$store.dispatch('ensureRoles')
    // },
    methods: {
      change(selectedItems) {

        if (!this.multiple) {
          this.$emit('select-item', this.selected)
          return
        }

        const difference = selectedItems
            .filter(x => !this.previousSelection.includes(x))
            .concat(this.previousSelection.filter(x => !selectedItems.includes(x)))
          || []

        const itemId = difference.length === 1
          ? difference.pop()
          : null

        if (itemId) {
          const wasAdded = selectedItems.includes(itemId)
          const action = wasAdded ? 'add' : 'remove'

          this.previousSelection = selectedItems

          this.$emit('select-item', this.selected)
          this.$emit('item-clicked', { itemId, action })
        }
      }
    }
  }
</script>
